// All monetary values are in integer cents (minor units). Every supported
// currency (USD/GBP/EUR/AUD/NZD/CAD) is 2-decimal, so cents = major × 100.
export default {
  weekly_regular: {
    description: "Weekly Access B (regular plan)",
    billing: "weekly",
    base_price: {
      USD: 1999,
      GBP: 1499,
      EUR: 1799,
      AUD: 2799,
      NZD: 3399,
      CAD: 2799,
    },
    discount: {
      description: "50% off first billing (fixed amount equivalent)",
      coupon_id: import.meta.env.VITE_STRIPE_WEEKLY_DISCOUNT_ID,
      values: {
        USD: { amount: 1000, final: 999 },
        GBP: { amount: 700, final: 799 },
        EUR: { amount: 900, final: 899 },
        AUD: { amount: 1400, final: 1399 },
        NZD: { amount: 1700, final: 1699 },
        CAD: { amount: 1400, final: 1399 },
      },
    },
    prices: {
      USD: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_USD,
      GBP: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_GBP,
      EUR: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_EUR,
      AUD: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_AUD,
      NZD: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_NZD,
      CAD: import.meta.env.VITE_STRIPE_PRICE_ID_WEEKLY_CAD,
    },
  },

  monthly: {
    description: "Monthly Access B",
    billing: "monthly",
    base_price: {
      USD: 3999,
      GBP: 2999,
      EUR: 3499,
      AUD: 5599,
      NZD: 6799,
      CAD: 5499,
    },
    discount: {
      description: "50% off first billing",
      coupon_id: import.meta.env.VITE_STRIPE_MONTHLY_DISCOUNT_ID,
      values: {
        USD: { amount: 2000, final: 1999 },
        GBP: { amount: 1500, final: 1499 },
        EUR: { amount: 1700, final: 1799 },
        AUD: { amount: 2800, final: 2799 },
        NZD: { amount: 3400, final: 3399 },
        CAD: { amount: 2700, final: 2799 },
      },
    },
    prices: {
      USD: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_USD,
      GBP: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_GBP,
      EUR: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_EUR,
      AUD: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_AUD,
      NZD: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_NZD,
      CAD: import.meta.env.VITE_STRIPE_PRICE_ID_MONTHLY_CAD,
    },
  },

  // ---------------------------------------------------------------------------
  // exp_wmq funnel (SHO-713). Amounts per currency as specified by the PM on
  // the ticket; each Stripe price carries them as `currency_options`.
  // ---------------------------------------------------------------------------
  exp_wmq_trial: {
    description: "WMQ 1-Week intro (recurs at the monthly rate)",
    billing: "weekly_trial",
    base_price: {
      USD: 3999,
      GBP: 2999,
      EUR: 3499,
      AUD: 5699,
      NZD: 6999,
      CAD: 5699,
    },
    discount: {
      description: "First 7 days introductory price (trial price, no coupon)",
      coupon_id: "",
      values: {
        USD: { amount: 3000, final: 999 },
        GBP: { amount: 2200, final: 799 },
        EUR: { amount: 2600, final: 899 },
        AUD: { amount: 4300, final: 1399 },
        NZD: { amount: 5200, final: 1799 },
        CAD: { amount: 4300, final: 1399 },
      },
    },
    // Single Stripe price with currency_options for all supported currencies.
    prices: import.meta.env.VITE_STRIPE_EXP_WMQ_PRICE_ID_MONTHLY_WITH_TRIAL,
  },

  exp_wmq_monthly: {
    description: "WMQ 1-Month Plan (intro then monthly recurring)",
    billing: "monthly",
    base_price: {
      USD: 3999,
      GBP: 2999,
      EUR: 3499,
      AUD: 5699,
      NZD: 6999,
      CAD: 5699,
    },
    discount: {
      description: "First month introductory price",
      coupon_id: import.meta.env.VITE_STRIPE_EXP_WMQ_MONTHLY_COUPON,
      values: {
        USD: { amount: 2000, final: 1999 },
        GBP: { amount: 1500, final: 1499 },
        EUR: { amount: 1700, final: 1799 },
        AUD: { amount: 2900, final: 2799 },
        NZD: { amount: 3500, final: 3499 },
        CAD: { amount: 2900, final: 2799 },
      },
    },
    prices: import.meta.env.VITE_STRIPE_EXP_WMQ_PRICE_ID_MONTHLY,
  },

  exp_wmq_quarterly: {
    description: "WMQ 3-Month Plan (intro then quarterly recurring)",
    billing: "quarterly",
    base_price: {
      USD: 7999,
      GBP: 5999,
      EUR: 6999,
      AUD: 11399,
      NZD: 13999,
      CAD: 11299,
    },
    discount: {
      description: "First quarter introductory price",
      coupon_id: import.meta.env.VITE_STRIPE_EXP_WMQ_QUARTERLY_COUPON,
      values: {
        USD: { amount: 4000, final: 3999 },
        GBP: { amount: 3000, final: 2999 },
        EUR: { amount: 3500, final: 3499 },
        AUD: { amount: 5700, final: 5699 },
        NZD: { amount: 7000, final: 6999 },
        CAD: { amount: 5600, final: 5699 },
      },
    },
    prices: import.meta.env.VITE_STRIPE_EXP_WMQ_PRICE_ID_QUARTERLY,
  },
};
